import { InjectionToken } from '@angular/core';

export const SERIES_NAME = new InjectionToken<string>('SERIES_NAME');
